<div class="container_upload_processing">
    <mat-stepper class="stepper_upload_processing" #stepper [selectedIndex]="0">
        <mat-step label="{{'common.update'|translate }}"></mat-step>
        <mat-step label="{{'import.match'|translate}}">
            <div class="container">
                <div class="quote_timeline">
                    <div class="timeline">
                        <div class="head">
                            <div class="top">
                                <div class="left_title">
                                    <div class="title">
                                        <h3 class="m-0"><strong>{{"common.imported_file"| translate }}</strong></h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="file_upload">
                            <div class="file">
                                <img src="assets/icones/xls.svg" alt="">
                                <span>{{file_name}}</span>
                            </div>
                            <div class="field category_field">
                                <label for="sheet">{{"common.sheet" | translate}}</label>
                                <select id="sheet" style="width: 100%;">
                                    <option *ngIf="responseMatching" selected [value]="responseMatching!.data!.sheet">{{responseMatching!.data!.sheet}}</option>
                                </select>
                            </div>
                            <div class="hearder_card">
                                <mat-slide-toggle [checked]="true" [disabled]="true"></mat-slide-toggle>
                                <span>{{"common.use_first_row_as_header"| translate}}</span>
                            </div>
                            <div class="field equality_field">
                                <label for="">{{"suppliers.suppliers"|translate}}</label>
                                <input type="text" [placeholder]="'suppliers.suppliers'|translate" [formControl]="supplierControl" [matAutocomplete]="auto"
                                  class="input">
                                <mat-autocomplete #auto="matAutocomplete">
                                  <ng-container *ngIf="filteredSuppliers$ | async as suppliers">
                                    <mat-option *ngFor="let supplier of suppliers" [value]="supplier.name" (click)="onSupplierSelected(supplier)">
                                      {{ supplier.name }}
                                    </mat-option>

                                    <mat-option [value]="supplierControl.value" class="add_option"
                                      *ngIf="suppliers.length === 0 && supplierControl.value"
                                      (click)="addNewElement(supplierControl.value, 'supplier')">
                                      <img src="assets/icones/add.svg" alt="">
                                      {{"common.add"|translate}} "{{ supplierControl.value}}"
                                    </mat-option>
                                  </ng-container>
                                </mat-autocomplete>
                                <span class="error_ms" *ngIf="supplierControl.touched && supplierControl.errors">{{"common.required_field"|translate}}</span>
                            </div>
                            <div class="field category_field">
                                <label for="sheet">{{"comparator.quote_expiration_date"| translate}}</label>
                                <input type="date" value="{{expirationDate.value | date: 'yyyy-MM-dd'}}" [formControl]="expirationDate">
                                <span class="error_ms" *ngIf="expirationDate.touched && expirationDate.errors">{{"common.required_field"|translate}}</span>
                            </div>
                            <div class="colomns"  *ngIf="responseMatching">
                                <ul style="width: 90%;margin: 0 auto;">
                                    <li>{{responseMatching!.data!.columns.length}} : {{"common.total_colomns"| translate}}</li>
                                    <li><span></span>{{missedColomns(responseMatching!.data!.columns,  selectedValues)}} : {{"common.missed_colomns"| translate}}</li>
                                </ul>
                                <div class="td_inline" style="margin-top: 10px;">
                                    <mat-progress-bar class="example-margin audio-progress-bar" [mode]="mode"
                                    [value]="selectedColomnsPercentage(responseMatching!.data!.columns, selectedValues)">
                                </mat-progress-bar>
                                    <span style="text-wrap: nowrap;">{{selectedColomnsPercentage(responseMatching!.data!.columns, selectedValues).toFixed(2)}}%</span>
                                </div>
                            </div>
                            <div class="field category_field colomns">
                                <b>{{"common.help"| translate}}</b>
                                <div class="content_card">
                                    <img src="assets/icones/hint.svg" alt="">
                                    <span class="light">{{ '---' }}</span>
                                </div>
                            </div>
                            <div class="foter_buttons">
                                <button type="button" class="save_btn_pop_up blue_btn" (click)="testAndResolve()">
                                    <span> {{"common.test_and_resolve_error"| translate}}</span>
                                    <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
                                </button>
                                <button type="button" class="save_btn_pop_up cancel_btn_pop_up" (click)="back()">
                                    <span>{{"common.cancel"| translate}}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right_container" *ngIf="responseMatching as response">
                    <div class="error_message" *ngIf="matchingErrorsResponse">{{matchingErrorsResponse.messages[0].message}}</div>
                    <div class="containers">
                        <div class="page_container">
                            <table class="listing_table">
                                <thead class="header_stiky">
                                    <tr class="head_table">
                                        <th>{{"import.file_column"| translate}}</th>
                                        <th class="alert_td"></th>
                                        <th>{{"import.wolsal_column"| translate}}</th>
                                        <th>{{"import.comment"| translate}}</th>
                                    </tr>
                                </thead>
                                <tbody class="scrollable_body_import">
                                    <tr class="body_table hover_tr" *ngFor="let item of response.data.columns; let i = index">
                                        <td class="td_block">
                                            <span class="bold">{{ item }}</span>
                                        </td>
                                        <td class="alert_td">
                                            <img *ngIf="!selectedValues[i]" src="../../../../../assets/icones/low-warning.svg" alt=""
                                            style="margin-right: 10px;">
                                        </td>
                                        <td>
                                            <select *ngIf="selectedValues[i]" style="width: 90%; font-size: 14px;" [(ngModel)]="selectedValues[i]" (change)="setSelectedValue(i, $event)">
                                              <option selected value=""></option>
                                              <option *ngFor="let item of response.data.fields" [value]="item.name">
                                                  {{item.string}}
                                              </option>
                                            </select>
                                            <select *ngIf="!selectedValues[i]" style="width: 90%; font-size: 14px;" [(ngModel)]="selectedValues[i]" (change)="setSelectedValue(i, $event)">
                                              <option selected value=""></option>
                                              <option *ngFor="let item of filteredFields" [value]="item.name">
                                                  {{item.string}}
                                              </option>
                                            </select>
                                        </td>
                                        <td>
                                            <!-- <div class="content_card">
                                                <img src="assets/icones/hint.svg" alt="">
                                                <span class="light">{{ '---' }}</span>
                                            </div> -->
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </mat-step>
        <mat-step label="{{'import.test'|translate}}">
            <div class="container">
                <div class="quote_timeline">
                    <div class="timeline">
                        <div class="head">
                            <div class="top">
                                <div class="left_title">
                                    <div class="title">
                                        <h3 class="m-0"><strong>{{"common.imported_file"| translate}}</strong></h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="file_upload">
                            <div class="file">
                                <img src="assets/icones/xls.svg" alt="">
                                <span>{{file_name}}</span>
                            </div>
                            <div class="field category_field">
                                <label for="sheet">{{"common.sheet"| translate}}</label>
                                <select id="sheet" style="width: 100%;">
                                    <option *ngIf="responseMatching"  selected [value]="responseMatching!.data!.sheet">{{responseMatching!.data!.sheet}}</option>
                                </select>
                            </div>
                            <div class="hearder_card">
                                <mat-slide-toggle [checked]="true" [disabled]="true"></mat-slide-toggle>
                                <span>{{"common.use_first_row_as_header"|translate}}</span>
                            </div>
                            <div class="field equality_field">
                                <label for="">{{"suppliers.suppliers"|translate}}</label>
                                <input type="text" [placeholder]="'suppliers.suppliers'|translate" value="{{supplierControl.value}}" readonly
                                  class="input">
                            </div>
                            <div class="field category_field">
                                <label for="sheet">{{"comparator.quote_expiration_date"| translate}}</label>
                                <input type="date" value="{{expirationDate.value | date: 'yyyy-MM-dd'}}" [formControl]="expirationDate">
                                <span class="error_ms" *ngIf="expirationDate.touched && expirationDate.errors">{{"common.required_field"|translate}}</span>
                            </div>
                            <div class="colomns" *ngIf="responseMatching">
                                <ul style="width: 90%;margin: 0 auto; ">
                                    <li><span></span>{{responseMatching!.data!.columns.length}} : {{"common.total_colomns"| translate}}</li>
                                    <li><span></span>{{missedColomns(responseMatching!.data!.columns,  selectedValues)}} : {{"common.missed_colomns" | translate}}</li>
                                </ul>
                                <div class="td_inline" style="margin-top: 10px;">
                                    <mat-progress-bar class="example-margin audio-progress-bar" [mode]="mode"
                                        [value]="selectedColomnsPercentage(responseMatching!.data!.columns, selectedValues)">
                                    </mat-progress-bar>
                                    <span style="text-wrap: nowrap;">{{selectedColomnsPercentage(responseMatching!.data!.columns, selectedValues).toFixed(2)}}%</span>
                                </div>
                            </div>
                            <div class="field category_field colomns">
                                <b>{{"common.help"|translate}}</b>
                                <div class="content_card">
                                    <img src="assets/icones/hint.svg" alt="">
                                    <span class="light">{{ '---' }}</span>
                                </div>
                            </div>
                            <div class="foter_buttons" *ngIf="true">
                                <label for="myfile" class="save_btn_pop_up blue_btn label_input" *ngIf="rowsErrorsResponse">
                                    <span>{{"import.re_import_file"| translate}}</span>
                                    <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
                                </label>
                                <input type="file" id="myfile" class="input_file" (change)="reaploadFile($event)">
                                <button type="button" class="save_btn_pop_up blue_btn" (click)="testAndResolve()" *ngIf="rowsErrorsResponse">
                                    <span>{{"common.test_and_resolve_error"|translate}}</span>
                                    <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
                                </button>
                                <button type="button" class="save_btn_pop_up blue_btn" (click)="nextToPreview()" *ngIf="!rowsErrorsResponse">
                                    <span>{{"comparator.comparator"|translate}}</span>
                                </button>
                                <button type="button" class="save_btn_pop_up cancel_btn_pop_up" (click)="stepper.previous()" *ngIf="rowsErrorsResponse">
                                    <span>{{"common.back"|translate | uppercase}}</span>
                                    <img alt="" src="../../../../../assets/icones/arrow_back.svg">
                                </button>
                                <button type="button" class="save_btn_pop_up cancel_btn_pop_up" (click)="back()">
                                    <span>{{"common.cancel"|translate}}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right_container">
                    <div class="check_to_imported_file" *ngIf="!rowsErrorsResponse">
                        <img src="assets/icones/succsess.svg" alt="">
                        <span>{{"import.congrat_your_file"|translate}}<br /> {{"import.imported_there"|translate}}</span>
                    </div>
                    <div class="containers" *ngIf="rowsErrorsResponse">
                        <div class="page_container">
                            <table class="listing_table">
                                <thead class="header_stiky">
                                    <tr class="head_third_step">
                                        <th>{{"import.error_type"| translate}}</th>
                                        <th>{{"import.error_line"| translate}}</th>
                                        <th>{{"common.description"| translate}}</th>
                                        <th>{{"import.solution"| translate }}</th>
                                        <th>{{"import.view_line_content"| translate}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="body_third_step body_table hover_tr" *ngFor="let error of rowsErrorsResponse.messages">
                                        <td class="td_block">
                                            <span class="tag">{{ error.type }}</span>
                                        </td>
                                        <td class="td_block">
                                            <span class="bold" *ngIf="error.rows">{{ error.rows.from + 2}}</span>
                                        </td>
                                        <td>
                                            <span *ngIf="error.message" class="bold">{{ error.message}}</span>
                                            <div *ngIf="error.messages"  class="bold">
                                                <ul>
                                                    <li *ngFor="let item of error.messages | slice:0:3">{{ item }}</li>
                                                    <span class="and_more" *ngIf="error.messages.length > 3">and {{ error.messages.length - 3 }} more</span>
                                                </ul>
                                            </div>
                                        </td>
                                        <td>
                                            <div *ngIf="!isRelationError(error.field)">
                                                <img src="assets/icones/hint.svg" alt="" style="margin-right: 5px;">
                                                <span>{{"import.modify_field_hint" | translate: {error_field: error.field } }}</span>
                                            </div>
                                            <select *ngIf="isRelationError(error.field)" style="width: 90%; font-size: 14px;" (change)="setSolution(error, $event)">
                                                <option value="prevent">{{"import.prevent_import"|translate}}</option>
                                                <option value="create_new_values">{{"import.create_new_values"|translate}}</option>
                                            </select>
                                        </td>
                                        <td>
                                            <!-- <div class="td_inline view_content" (click)="viewErrorContent(error, rowsErrorsResponse)">
                                                <img src="assets/icones/eye.svg" alt="">
                                                <span class="light" style="text-wrap: nowrap;font-size: smaller;">
                                                  {{"import.view_content"| translate}}</span>
                                            </div> -->
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </mat-step>
        <mat-step label="{{'comparator.comparator'| translate }}">
            <div class="preview_container" *ngIf="productsImport.length > 0">
                <div class="table_products">
                    <div class="header_preview">
                        <h2>{{ productsImport.length}} {{"Catalogs.products_included"| translate}}</h2>
                    </div>
                    <div class="page_container preview_container_products">
                        <table class="listing_table preview">
                            <thead class="header_stiky">
                                <tr class="head_preview">
                                    <th>{{"common.image"| translate}}</th>
                                    <th>{{"common.name"| translate}} <br> {{"inventory.sku"|translate}}</th>
                                    <th class="number_clmn">{{"comparator.imported_price"| translate}}</th>
                                    <th class="number_clmn">{{"comparator.inventory_price"|translate}} <br> {{"comparator.different"|translate}}</th>
                                    <th>{{"comparator.other_prices"| translate}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let product of productsImport">
                                    <tr class="body_preview hover_tr">
                                        <td class="first_td">
                                            <img *ngIf="product['image']" class="listing_image" [src]="baseUrl + product['image']" alt="">
                                            <img *ngIf="!product['image']" class="listing_image" src="assets/icones/no-image.png" alt="">
                                        </td>
                                        <td class="description_cell td_block cursor number_clmn_offer">
                                            <span *ngIf="product['name']" class="descr_elemnt bold_span">{{ product['name'] }}</span>
                                            <span *ngIf="!product['name']" class="descr_elemnt bold_span no_product">{{ "comparator.product_not_exist" | translate }}</span>
                                            <span class="descr_elemnt light_span">{{ product['sku'] }}</span>
                                        </td>
                                        <td class="number_clmn">
                                            {{ product['price']}} €
                                        </td>
                                        <td class="number_clmn">
                                            <div class="number_clmn_offer" *ngIf="product['actual_price']">
                                                <span>{{ product['actual_price']}} €</span>
                                                <span class="offer_span" [class.danger]="product['price'] > product['actual_price']"> {{ (product['price'] - product['actual_price']).toFixed(2) }} € </span>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="td_offers">
                                                <div *ngIf="product['other_imported_prices'] && product['other_imported_prices'].length > 0">
                                                    <button class="btn_show_more" [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger">
                                                        + {{product['other_imported_prices'].length}}
                                                        <mat-icon *ngIf="!menuTrigger.menuOpen">keyboard_arrow_down</mat-icon>
                                                        <mat-icon *ngIf="menuTrigger.menuOpen">keyboard_arrow_up</mat-icon>
                                                        <span *ngIf="!menuTrigger.menuOpen">{{"inventory.SHOW"|translate}}</span>
                                                        <span *ngIf="menuTrigger.menuOpen">{{"inventory.HIDE"|translate}}</span>
                                                    </button>
                                                    <mat-menu #menu="matMenu">
                                                        <div class="mat_menu_item">
                                                            <div class="header">
                                                                <div class="menu_title">{{product['other_imported_prices'].length}} {{"comparator.other_prices"| translate}}</div>
                                                            </div>
                                                            <div class="item_menu" *ngFor="let item of product['other_imported_prices']">
                                                                <div>{{item.supplier}}</div>
                                                                <div class="file_div">
                                                                    <div class="file_name" (click)="downloadFile(item)">
                                                                        <img src="../../../../../assets/icones/icons_xls.svg" alt="">
                                                                        <span class="file_name_span">{{item.file_name}}</span>
                                                                        <img src="../../../../../assets/icones/icon_download.svg" alt="">
                                                                    </div>
                                                                    <div class="lowest_price" *ngIf="isLowestPrice(product['other_imported_prices'], item)">
                                                                        {{"comparator.lowest_price"| translate}}
                                                                    </div>
                                                                </div>
                                                                <div class="expiration_date">{{item.expiration_date }} ({{item.expiration_date | daysAgoOrLeft}})</div>
                                                            </div>
                                                        </div>
                                                    </mat-menu>
                                                </div>
                                                <div *ngIf="product['other_imported_prices'] && product['other_imported_prices'].length > 0">
                                                    <span class="offer_span">{{getBetterOffers(product['other_imported_prices'], product['price'])}} {{"comparator.better_offer"|translate}}</span>
                                                </div>
                                            </div>
                                            <div>
                                                <span *ngIf="!product['other_imported_prices'] || product['other_imported_prices'].length == 0">
                                                    {{"comparator.no_previous_data"| translate}}
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                    <div class="footer_statistic">
                        <div></div>
                        <div class="statistic">
                            {{"common.total_products"| translate}} <br> <strong>{{productsImport.length}}</strong>
                        </div>
                        <div></div>
                        <div class="statistic custom_statistic">
                            <span>{{"comparator.better_offers" | translate}} <br> <strong>{{getTotalBetterOffers(productsImport)}}</strong></span>
                        </div>
                        <div class="statistic">{{"comparator.better_offers" | translate}} <br> <strong>{{getTotalOthersBetterOffers(productsImport)}}</strong></div>
                    </div>
                </div>
                <div class="foter_buttons btns_commit" *ngIf="true">
                    <button type="button" class="action_btn btn_edit" (click)="saveAsDraft()">
                        <mat-icon style="color: #6449DB;">save</mat-icon>
                        <span>{{"common.save"|translate | uppercase}} AS {{"common.draft"| translate}}</span>
                    </button>
                    <button type="button" class="save_btn_pop_up green_btn" (click)="commit()">
                        <span>{{"common.commit"| translate}}</span>
                        <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
                    </button>
                </div>
            </div>
        </mat-step>
        <mat-step label="{{'common.commit'|translate }}"></mat-step>
    </mat-stepper>
</div>
